import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function PopupDialog({ open, title, onClose, children, maxWidth = "sm" }) {
  // Props validation for maxWidth
  if (typeof maxWidth !== "string") {
    console.warn("PopupDialog: maxWidth must be a string");
  }
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={maxWidth} slotProps={{ paper: { sx: { borderRadius: 2 } } }}>
      {title && (
        <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontWeight: 700, color: "#233529" }}>
          {title}
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
      )}
      <DialogContent sx={{ pt: title ? 1 : 2 }}>{children}</DialogContent>
    </Dialog>
  );
}
